import React from 'react';
import { motion } from 'framer-motion';

const VEHICLE_EMOJI: Record<string, string> = {
  'garbage-truck': '🚛',
  'snow-plow': '🚜',
  'fire-truck': '🚒',
  train: '🚂',
  bus: '🚌',
  'ice-cream-truck': '🍦',
  tractor: '🚜',
  excavator: '🚧',
  boat: '⛴️',
  any: '🧽',
};

export interface VehicleCardProps {
  title: string;
  vehicle: string;
  status: 'design-ready' | 'planned';
  onClick?: () => void;
  dimmed?: boolean;
  /** Levels available for the child's age. */
  levelCount?: number;
}

export const VehicleCard: React.FC<VehicleCardProps> = ({
  title,
  vehicle,
  status,
  onClick,
  dimmed = false,
  levelCount = 15,
}) => {
  const emoji = VEHICLE_EMOJI[vehicle] ?? '🚗';
  const interactive = status === 'design-ready' && Boolean(onClick);

  return (
    <motion.button
      type="button"
      disabled={!interactive}
      onClick={onClick}
      whileTap={interactive ? { scale: 0.97 } : undefined}
      className={`w-full min-h-[160px] rounded-3xl p-6 text-left shadow-lg transition ${
        interactive
          ? 'bg-white hover:shadow-xl cursor-pointer'
          : 'bg-white/50 cursor-default'
      } ${dimmed ? 'opacity-60' : ''}`}
      data-name={`vehicle-card-${vehicle}`}
    >
      <div className="text-6xl mb-3" aria-hidden>
        {emoji}
      </div>
      <h3 className="font-display text-2xl md:text-3xl font-bold text-gray-800">{title}</h3>
      {status === 'planned' ? (
        <p className="mt-2 font-body text-gray-500">Kommer snart</p>
      ) : (
        <p className="mt-2 font-body text-[#27A9E1]">{levelCount} nivåer</p>
      )}
    </motion.button>
  );
};

export default VehicleCard;
